function initDestinationsMap(){
    "use strict";
    $('.destination-trigger').click(function() {
    	var link = $(this).data('link');
    	var ind = $(this).data('index');
    	$('.destination-item').removeClass('active');
	  	$(this).parent().addClass('active');
        $('div.marker-wrapper').each(function(index, el) {
            if( ! $(this).hasClass('olympic-marine-marker') ){
                $(this).hide();
             }
        });
        
         $('#marker_'+ind).show();
	  	return false;
	});
     initMap();

}



function initMap(){

    var center = [0, 0];

    if( $( ".marker-wrapper" ).length>0 ){
         var  initial_latitude = 37.9908997;
         var  initial_longtitude = 23.70332;
         center = ol.proj.fromLonLat([initial_longtitude, initial_latitude]);
    }
    var view =  new ol.View({
        center: center,
        zoom: 6
    });

    var vtLayer =  new ol.layer.Tile({
      source: new ol.source.XYZ({
        url: 'https://api.mapbox.com/styles/v1/ntoudis/ck5p5pi5e14h91ip24qflorn6/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoibnRvdWRpcyIsImEiOiJjazBzMG42OWUwYjFiM2JxbGJhd2g5ejZlIn0.AnTGsb9pMBvf1ceHapMz4g'
      })
    });

     var map = new ol.Map({
        layers: [
       		 vtLayer
        ],
        target: 'destination-map',
        view:view
    });

     $( ".marker-wrapper" ).each(function(index) {
          var  latitude = Number($( this ).data( "latitude" ));
          var  longtitude = Number($( this ).data( "longtitude" ));
          var element = this;

          var pos = ol.proj.transform([longtitude, latitude ], 'EPSG:4326', 'EPSG:3857');
         
          var marker = new ol.Overlay({
             element: element,
             position: pos,
             positioning: 'center-center',
         });

         map.addOverlay(marker);
     });

}


